import { LoaderFunctionArgs } from 'react-router-dom'
import { protectedLoader } from './protectLoader'
import {
  CUSTOMER_ADMIN,
  CUSTOMER_SUPPORT,
  DISTRIBUTOR_ADMIN,
  DISTRIBUTOR_SUPPORT,
  PORTAL_ADMIN,
  PORTAL_SUPPORT,
} from '.'
import { lazyRoute } from '../utils/lazyRoute'

const customerRoutes = [
  {
    path: '/customers',
    lazy: lazyRoute(() => import('../pages/Portal/Customers')),
    loader: (args: LoaderFunctionArgs) =>
      protectedLoader(args, {
        allowedRoles: [
          PORTAL_ADMIN,
          PORTAL_SUPPORT,
          DISTRIBUTOR_ADMIN,
          DISTRIBUTOR_SUPPORT,
        ],
      }),
  },
  {
    path: '/organization/:branchId?',
    lazy: lazyRoute(() => import('../pages/Portal/Organization')),
    loader: (args: LoaderFunctionArgs) =>
      protectedLoader(args, {
        allowedRoles: [
          PORTAL_ADMIN,
          PORTAL_SUPPORT,
          DISTRIBUTOR_ADMIN,
          DISTRIBUTOR_SUPPORT,
          CUSTOMER_ADMIN,
          CUSTOMER_SUPPORT,
        ],
      }),
  },
  {
    path: '/organization/details/:branchId',
    lazy: lazyRoute(
      () => import('../pages/Portal/Organization/OrganizationDetails'),
    ),
    loader: (args: LoaderFunctionArgs) =>
      protectedLoader(args, {
        allowedRoles: [
          PORTAL_ADMIN,
          PORTAL_SUPPORT,
          DISTRIBUTOR_ADMIN,
          DISTRIBUTOR_SUPPORT,
          CUSTOMER_ADMIN,
          CUSTOMER_SUPPORT,
        ],
      }),
  },
]

export default customerRoutes
